export default "__VITE_ASSET__BwWT8z1K__"